import {
  ArrayPath,
  FieldValues,
  useFieldArray,
  useFormContext,
  WatchObserver,
} from 'react-hook-form';

export const useFormArray = <FormContext extends FieldValues>(
  fieldName: ArrayPath<FormContext>,
  defaultNewValue: FormContext[ArrayPath<FormContext>[number]]
) => {
  const { control, watch } = useFormContext<FormContext>();
  const { fields, append, insert, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const addElement = (index: number, override?: FormContext[ArrayPath<FormContext>]) => {
    insert(index + 1, override || defaultNewValue);
  };

  const appendElement = (override?: FormContext[ArrayPath<FormContext>]) => {
    append(override || defaultNewValue);
  };

  const deleteElement = (index: number) => {
    remove(index);
  };

  const arrayValue = watch(fieldName as WatchObserver<FormContext>) || [];

  return {
    fields,
    addElement,
    deleteElement,
    appendElement,
    arrayValue,
  };
};
